import { render } from "./DataDokumen.vue?vue&type=template&id=2df4ffba"
import script from "./DataDokumen.vue?vue&type=script&lang=js"
export * from "./DataDokumen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__